"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6304],{

/***/ 86304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7h1c1.7 0 3 1.3 3 3v5c0 1.7-1.3 3-3 3h-1v1c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V6.8C2 5.3 3.3 4 4.8 4h1.1c.3 0 .6-.2.7-.4C7.1 2.6 8 2 9.1 2h1.8c1.1 0 2 .6 2.5 1.6.1.2.4.4.7.4h1.1C16.7 4 18 5.3 18 6.8V7zM4.8 6c-.4 0-.8.4-.8.8V7h12v-.2c0-.4-.4-.8-.8-.8h-1.1c-1.1 0-2-.6-2.5-1.6-.1-.2-.4-.4-.7-.4H9.1c-.3 0-.6.2-.7.4C7.9 5.4 7 6 5.9 6H4.8zM15 20c.6 0 1-.4 1-1V9H4v10c0 .6.4 1 1 1h10zm4-4c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1h-1v7h1zM5 13c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1v-4zm4 0c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1v-4zm5-1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1v-4c0-.6-.4-1-1-1z"
}), "Bar"));


/***/ })

}]);